import React from 'react'
import { useTranslation } from 'react-i18next'

import LogoNoText from '../../assets/images/svg/logo-no-text.svg'
import LogoEN from '../../assets/images/svg/logo.en.svg'
import LogoFR from '../../assets/images/svg/logo.fr.svg'
import LogoNL from '../../assets/images/svg/logo.nl.svg'
import { dutch, french, english } from '../../i18n/languages'


const Logo = ({ collapsed = false, ...other }) => {
    const { i18n } = useTranslation()

    let svgImage
    if (collapsed) svgImage = LogoNoText
    else if (i18n.language === dutch) svgImage = LogoNL
    else if (i18n.language === french) svgImage = LogoFR
    else if (i18n.language === english) svgImage = LogoEN
    else svgImage = LogoNL


    return (
        <img
            src={svgImage}
            alt="website logo"
            {...other}
        />
    )
}

export default Logo
